import { Formatting } from "../../utils/formatting";
import { Social } from "../../utils/social";

export class AgentProfile {
    public agentCode: string;
    public firstName: string;
    public lastName: string;
    public officePhone: string;
    public officeExtension: string;
    public facebookProfileId: string;
    public twitterHandle: string;
    public linkedInProfileId: string;
    public id: number;
    public acid: string;

    public get phoneLink(): string {
        return this.officeExtension
            ? `tel:+1${this.officePhone},${this.officeExtension}`
            : `tel:+1${this.officePhone}`;
    }

    public get formattedPhone(): string {
        return Formatting.formatPhone(this.officePhone, this.officeExtension);
    }

    public get imageUrl(): string {
        return Social.buildImageUrl(this.id);
    }

    public get name(): string {
        return `${this.firstName} ${this.lastName}`;
    }

    public get contactUrl(): string {
        return `/find-agent/contact-agent/agent/${this.acid}`;
    }

    public get facebookUrl(): string {
        if (this.facebookProfileId)
            return Social.buildFacebookUrl(this.facebookProfileId);
        return '#';
    }

    public get twitterUrl(): string {
        if (this.twitterHandle)
            return Social.buildTwitterUrl(this.twitterHandle);
        return '#';
    }

    public get linkedinUrl(): string {
        if (this.linkedInProfileId)
            return Social.buildLinkedinUrl(this.linkedInProfileId);
        return '#';
    }

    public static fromJs = (data: any): AgentProfile => {
        const profile = new AgentProfile();
        Object.assign(profile, data);
        return profile;
    }
}